import { SET_PARTNER_LINKS, SET_IS_INTEGRATION_ADMIN_ACCOUNT, CLEAR } from './actionTypes';
import { PartnerLink } from '../types';

const setPartnerLinks = (payload: PartnerLink[]) => ({
  type: SET_PARTNER_LINKS,
  payload,
});

const setIsIntegrationAdminAccount = (payload: boolean) => ({
  type: SET_IS_INTEGRATION_ADMIN_ACCOUNT,
  payload,
});

const clearState = () => ({
  type: CLEAR,
});

export const aftermarketPartnerActions = {
  setPartnerLinks,
  setIsIntegrationAdminAccount,
  clearState,
};
